/* unplugin-vue-components disabled */import script from "./AddressEditUS.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressEditUS.vue?vue&type=script&setup=true&lang=js"

import "./AddressEditUS.vue?vue&type=style&index=0&id=bcd62356&lang=scss"

const __exports__ = script;

export default __exports__